const priceFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});

export const formatPrice = (price: number) => priceFormatter.format(price / 100);

// Estimates of ten thousand or more are abbreviated (790K, 1.03M) so that a
// range always fits on a single line. Smaller numbers, such as the per category
// figures, are shown in full.
const COMPACT_ESTIMATE_THRESHOLD = 10_000;

const compactEstimateFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 2,
});

const fullEstimateFormatter = new Intl.NumberFormat('en-US');

export const formatEstimate = (estimate: number) =>
  estimate >= COMPACT_ESTIMATE_THRESHOLD
    ? compactEstimateFormatter.format(estimate)
    : fullEstimateFormatter.format(estimate);

export const formatEstimateRange = (min: number, max?: number | null) =>
  max && max !== min ? `${formatEstimate(min)} - ${formatEstimate(max)}` : formatEstimate(min);
